const ALLOWED_TAGS = new Set(['B','I','U','S','MARK','OL','UL','LI','P','DIV','BR','TABLE','TBODY','TR','TD','TH','SPAN','IMG','INPUT']);

const ALLOWED_ATTRS = {
  IMG: (name, value) => (name === 'src' && (value.startsWith('data:image/') || /^https?:\/\//.test(value))) || name === 'data-drawing-id',
  INPUT: (name) => name === 'type' || name === 'checked',
  TD: (name) => name === 'colspan' || name === 'rowspan',
  TH: (name) => name === 'colspan' || name === 'rowspan',
  // Allow background-color style on span (produced by execCommand hiliteColor for highlight)
  SPAN: (name, value) => name === 'style' && /^background-color:\s*[^;]+;?\s*$/.test(value),
};

export function sanitizeHTML(dirty) {
  if (!dirty) return '';
  const container = document.createElement('div');
  container.innerHTML = dirty;

  const walk = (node) => {
    const children = Array.from(node.childNodes);
    for (const child of children) {
      if (child.nodeType === 3) continue; // text node — keep as-is
      if (child.nodeType !== 1) { child.remove(); continue; }

      const tag = child.tagName.toUpperCase();

      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'IFRAME' || tag === 'OBJECT') {
        child.remove();
        continue;
      }

      if (!ALLOWED_TAGS.has(tag)) {
        // Unwrap: replace element with its children
        const frag = document.createDocumentFragment();
        while (child.firstChild) frag.appendChild(child.firstChild);
        node.replaceChild(frag, child);
        continue;
      }

      // Strip disallowed attributes
      const attrFilter = ALLOWED_ATTRS[tag];
      const attrsToRemove = [];
      for (const attr of child.attributes) {
        if (!attrFilter || !attrFilter(attr.name, attr.value)) {
          attrsToRemove.push(attr.name);
        }
      }
      attrsToRemove.forEach(a => child.removeAttribute(a));

      // Special: input must be type=checkbox only
      if (tag === 'INPUT' && child.getAttribute('type') !== 'checkbox') {
        const frag = document.createDocumentFragment();
        node.replaceChild(frag, child);
        continue;
      }

      walk(child);
    }
  };

  walk(container);
  return container.innerHTML;
}

// stripTags is mirrored from backend/services/html/stripPlainText.js via
// scripts/sync-html-utils.mjs — re-exported here so existing imports keep working.
export { stripToPlainText as stripTags } from './_generated/htmlStrip.js';
